// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'regions';

const Model = class Regions extends BaseModel {
  static modelName = 'Regions';

  static instanceDefaults() {
    return {
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
